module.exports = __webpack_public_path__ + "images/category_lp/audio_instrument/banner_e7f31b966b441ea18039449a32102ef1.png";